import { MenuItem } from '../../services/MenuService';

export interface MenuState {
  menuStructure: MenuItem[] | null;
  loading: boolean;
  error: string | null;
  lastFetchTime: number | null;
}

const initialState: MenuState = {
  menuStructure: null,
  loading: false,
  error: null,
  lastFetchTime: null,
};

interface MenuAction {
  type: string;
  payload?: any;
}

export const menuReducer = (state = initialState, action: MenuAction): MenuState => {
  switch (action.type) {
    case 'MENU_FETCH_START':
      return {
        ...state,
        loading: true,
        error: null,
      };

    case 'MENU_FETCH_SUCCESS':
      return {
        ...state,
        menuStructure: action.payload,
        loading: false,
        error: null,
        lastFetchTime: Date.now(),
      };

    case 'MENU_FETCH_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload || 'Failed to fetch menu',
      };

    case 'MENU_CLEAR':
      return initialState;

    default:
      return state;
  }
};

export default menuReducer;
